import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { NbButton, NbInput } from "../../components/nb";
import { BadgeCheck, Search } from "lucide-react";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/admin/users", { params: q ? { q } : {} }); setUsers(data); } catch {}
  };
  useEffect(() => { load(); }, []);

  const suspend = async (id) => { const { data } = await api.post(`/admin/users/${id}/suspend`); toast.success(`User ${data.status}.`); load(); };
  const verify = async (id) => { await api.post(`/admin/users/${id}/verify`); toast.success("Verification toggled."); load(); };
  const del = async (id) => { await api.delete(`/admin/users/${id}`); toast.success("User deleted."); load(); };

  return (
    <div>
      <h1 className="font-head font-black text-4xl tracking-tighter mb-1">Users</h1>
      <p className="text-gray-600 font-medium mb-6">Manage all platform members.</p>
      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex gap-2 mb-6 max-w-md">
        <NbInput data-testid="admin-user-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email" />
        <NbButton type="submit"><Search className="w-4 h-4" /></NbButton>
      </form>

      <div className="bg-white nb-border nb-shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-[#F3F3F1] nb-border border-x-0 border-t-0 font-head font-bold uppercase text-xs">
            <th className="text-left p-3">User</th><th className="text-left p-3">Status</th><th className="text-left p-3">Plan</th><th className="text-right p-3">Actions</th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="nb-border border-x-0 border-t-0" data-testid={`admin-user-${u.id}`}>
                <td className="p-3"><div className="font-bold flex items-center gap-1">{u.name}{u.verified_badge && <BadgeCheck className="w-4 h-4 text-[#D4AF37]" fill="#0A0A0A" />}</div><div className="text-gray-500 text-xs">{u.email}</div></td>
                <td className="p-3"><span className={`px-2 py-0.5 nb-border text-xs font-bold uppercase ${u.status === "suspended" ? "bg-[#EF4444] text-white" : "bg-[#10B981] text-white"}`}>{u.status}</span></td>
                <td className="p-3"><span className="font-bold uppercase text-xs">{u.membership}</span></td>
                <td className="p-3">
                  <div className="flex gap-1 justify-end flex-wrap">
                    <button onClick={() => verify(u.id)} data-testid={`verify-user-${u.id}`} className="px-2 py-1 bg-[#D4AF37] nb-border text-xs font-bold uppercase nb-hover">Verify</button>
                    <button onClick={() => suspend(u.id)} data-testid={`suspend-user-${u.id}`} className="px-2 py-1 bg-[#D4AF37] nb-border text-xs font-bold uppercase nb-hover">{u.status === "suspended" ? "Unsuspend" : "Suspend"}</button>
                    <button onClick={() => del(u.id)} data-testid={`delete-user-${u.id}`} className="px-2 py-1 bg-[#EF4444] text-white nb-border text-xs font-bold uppercase nb-hover">Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && <div className="p-10 text-center text-gray-500 font-medium">No users found.</div>}
      </div>
    </div>
  );
}
